import React from 'react';
import CarrosEletricos from '../components/templates/CarrosEletricos';

function CarrosEletricosPage() {
  return <CarrosEletricos />;
}

export const config = {
  amp: false,
};

export default CarrosEletricosPage;
